import { Fragment } from 'react'

import { useDateLocale, useTimeZone } from '../../../../../../hooks'
import {
  getTableRowQaProps,
  TableCellFreeSpaceFiller,
  TableRowContextActions,
  useTableRowActions,
  useTableRowModClassName,
} from '../../../../../Table'

import { renderListingProfileViewingsCell } from './ListingProfileViewingsRow.utils'

import * as styles from './ListingProfileViewingsRow.module.css'

function ListingProfileViewingsRow({
  actionLeft,
  columns,
  emptyColumnSize,
  focusedRow,
  getActions,
  getArrowNavigationItemProps,
  index,
  isResizing,
  item,
  resizingColumn,
  showCellBorder,
  ...restProps
}) {
  const locale = useDateLocale()
  const timezone = useTimeZone()

  const {
    handleCallAction,
    handleClick,
    handleMouseDown,
    handleMouseEnter,
    handleMouseLeave,
  } = useTableRowActions({ item, ...restProps })

  const className = useTableRowModClassName({
    className: styles.ListingProfileViewingsRow,
    isActive: focusedRow === item.id,
  })

  return (
    <div
      {...getTableRowQaProps()}
      {...getArrowNavigationItemProps?.(index)}
      className={className}
      onClick={handleClick}
      onMouseDown={handleMouseDown}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      {columns.map(column => (
        <Fragment key={column.name}>
          {renderListingProfileViewingsCell({
            isActive: column.name === resizingColumn,
            isResizing,
            item,
            locale,
            name: column.name,
            showCellBorder,
            timezone,
            width: column.width,
          })}
        </Fragment>
      ))}
      <TableCellFreeSpaceFiller width={emptyColumnSize} />
      {getActions?.(item)?.length > 0 ? (
        <TableRowContextActions
          actionLeft={actionLeft}
          focusedRow={focusedRow}
          getActions={getActions}
          item={item}
          onCallAction={handleCallAction}
        />
      ) : null}
    </div>
  )
}

export default ListingProfileViewingsRow
